import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorRecord } from '@pulpo/pulpo-models';

@Component({
  selector: 'booking-record-error',
  templateUrl: './booking-record-error.component.html',
  styleUrls: ['./booking-record-error.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class BookingRecordErrorComponent {
  @Input() errorRecord: ErrorRecord;
}
